module.exports = {
	"articleTitle1": "The Best of Ann Arbor 2011",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "The Chop House",
	"articleLink1": "https://www.michigandaily.com/arts/best-ann-arbor-2011",
	"articleLink2": "https://www.michigandaily.com/content/anti-populist-guide-valentines-night-out-town",
	"articleSnippet1": "Apr 10, 2011 ... Impress your significant other with a trip to one of Ann Arbor's swankiest and \npriciest dining venues: The Chop House. The Main Street ...",
	"articleSnippet2": "Feb 14, 2002 ... If you plan to bring your date to Pizza House tonight, you should have ... Real \nSeafood Company (341 S. Main St.), The Chop House (322 S.",
	"foodRecommendations": [],
	"articleTitle2": "An anti-populist guide to a Valentine''s night out on the town",
	"address": "322 S Main St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.278797,
		"lng": -83.7489
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/chophouse.json
// module id = 849
// module chunks = 0